import React, { useEffect, useRef, useState } from "react";
import { FilterProps } from "../../../common/types/FilterProps"
import { Form, Formik, FormikProps } from "formik";
import FormObserver from "../FormElements/FormObserver";
import { FormInput, FormSelector } from "../FormElements";
import { isLogoAppProject } from "../../../common/helpers/globalHelpers";
import { TbDots } from "react-icons/tb";
import Button from "../Elements/Button";
import { buttonTexts } from "../../../constants/texts/buttonTexts";
import FormFiltersShortList from "../FormElements/FormFiltersShortList";
import { updateIsResetForm } from "../../../store/slices/formHelperSlice";
import { useDispatch } from "react-redux";
import { statusOptions } from "../../../constants/options/statusOptions";
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { yesNoOptions } from "../../../constants/options/yesNoOptions";
import { getSelectedValueFromId } from "../../../common/helpers/selectBoxHelper";
import paymentApi from "../../../common/api/paymentApi";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";
import { ThunkDispatch } from "redux-thunk";
import { getAllPaymentSet } from "../../../store/slices/paymentSetSlice";

type FilterTypes = {
    paymentSetDesc: string,
    status: number,
    paymentProvider: number,
    isDefaultPaymentSet: number
}

const initialValues = {
    paymentSetDesc: "",
    status: 0,
    paymentProvider: 0,
    isDefaultPaymentSet: 0
}

const Filters = React.forwardRef<HTMLDListElement | any, FilterProps>(({ isOpen, setFiltersIsOpen }, ref) => {

    const formRef = useRef<FormikProps<typeof initialValues>>(null);
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const [formValues, setFormValues] = useState<FilterTypes>(initialValues);
    const [posList, setPosList] = useState<any[]>([]);

    const { firmInformations } = useRecoilValue(tenantState);
    const { licenseKey, taxCode } = firmInformations;

    useEffect(() => {
        handlePosList();
    }, []);

    const onSubmit = async (values: FilterTypes) => {
        const apiParams = { licenseKey: licenseKey, taxCode: taxCode };
        const params = {
            parameters: {
                paymentSetDesc: values.paymentSetDesc,
                paymentSetStatus: values.status,
                isDefaultPaymentSet: values.isDefaultPaymentSet,
                paymentProvider: values.paymentProvider
            },
            apiParams: apiParams
        }

        const result = await dispatch(getAllPaymentSet(params));

        dispatch(getAllPaymentSet(params));
        setFiltersIsOpen(false);
    }

    const submitForm = () => {
        formRef.current?.submitForm();
    };

    const clearFilters = () => {
        dispatch(updateIsResetForm(true));
        setTimeout(() => {
            dispatch(updateIsResetForm(false));
        }, 1000);
        formRef.current?.resetForm();
        submitForm();
    };

    const onUpdate = (value: any) => {
        setFormValues(Object.assign(formValues, value));
        submitForm();
    };

    const handlePosList = async () => {
        const data = await commonNetwork.get("/virtualpos");
        var poslist = [];
        if (data.isSuccess) {
            var res = data.data.data;
            poslist.push({
                value: 0,
                label: "Tümü",
            });
            for (let i = 0; i < res.length; i++) {
                const element = res[i];
                poslist.push({
                    value: element.vpid,
                    label: element.vpdisplayname ? element.vpdisplayname : element.bankname,
                });
            }
            setPosList(poslist);
        } else {
            toast.error(data.errorMessage);
        }
    }

    const fields = [
        {
            key: "paymentSetDesc",
            label: "Ödeme Kuralı Açılaması",
            type: "text"
        },
        {
            key: "status",
            label: "Durumu",
            type: "select",
            options: statusOptions
        },
        {
            key: "paymentProvider",
            label: "Ödeme Altyapısı",
            type: "select",
            options: posList
        }
    ];

    return (
        <Formik
            innerRef={formRef}
            initialValues={initialValues}
            onSubmit={onSubmit}
        >
            {({
                values
            }) => (
                <Form>
                    <FormObserver
                        watch={(val: any) => {
                            setFormValues(val);
                        }}
                    />
                    <div className={`mt-3 mx-4 mb-3 px-4 py-2 bg-white shadow-md rounded-md ${!isOpen ? "hidden" : ""}`}>
                        <div className="grid grid-cols-3 gap-4 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3">
                            <div className="flex flex-col justify-start px-0">
                                <div className="mt-1">
                                    <FormInput
                                        label="Ödeme Kuralı Açıklaması"
                                        name="paymentSetDesc"
                                        type="text"
                                        rightIcon={isLogoAppProject() && (
                                            <TbDots
                                                className="sm:block h-6 w-6 text-black hidden cursor-pointer"
                                                aria-hidden="true"
                                                color="#0090FF"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col justify-start px-0">
                                <div className="mt-1">
                                    <FormSelector
                                        label="Durumu"
                                        name="status"
                                        options={statusOptions}
                                        value={getSelectedValueFromId(values.status, statusOptions)}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col justify-start px-0">
                                <div className="mt-1">
                                    <FormSelector
                                        label="Ödeme Altyapısı"
                                        name="paymentProvider"
                                        options={posList}
                                        value={getSelectedValueFromId(values.paymentProvider, posList)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex justify-end mt-2 mr-0'>
                            <Button
                                type='button'
                                color='gray'
                                hover='gray'
                                size='xs'
                                className='mr-3'
                                callback={clearFilters}
                            >
                                <img src="/icons/delete-blue.svg" alt="deleteFilter" />
                                <span className='ml-3'>Filtreyi Temizle</span>
                            </Button>
                            <Button type='submit' color='primary' hover='primary' size='xs' >
                                <img src="/icons/prepare-white.svg" alt="prepare" />
                                <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
                            </Button>
                        </div>
                    </div>
                    <div className={`m-4 px-4 py-3 bg-white shadow-md rounded-md ${isOpen ? "hidden" : ""}`}>
                        <FormFiltersShortList
                            formValues={{
                                ...values
                            }}
                            fields={fields}
                            initialValues={initialValues}
                            callback={(val: any) => onUpdate(val)}
                            clearFilter={() => {
                                clearFilters();
                                submitForm();
                            }}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
});

export default Filters;